function addBagsettocart(){
      var form = jQuery('.spaced-section.product form');
      var formID = jQuery('.spaced-section.product form').attr('id');
      var variantSelector = jQuery('.spaced-section.product form .variant-selector.js-hidden');
 	  var variantID= jQuery(variantSelector).val();
      var extraProductID = '<input type="hidden" name="id[]" value="42037653733535"/>';
      jQuery(extraProductID).appendTo(form);
      jQuery(variantSelector).attr('name','id[]');
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: [variantID, 42037653733535]
        },
        dataType: 'json',           
        success: function() {
			jQuery('.header-items__cart-link > a > span').click();
        },
        error: function() {
          	alert('Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
        }
      
      });  
  
}
function cartAdded(){
	setTimeout(
  function() 
  {
    location.href='/cart';
  }, 1500);
}
jQuery(document).on('click','#template--15470994129055__1646147172d920dc91 .video-container__media',function(){
    jQuery(this).siblings('.video-container__play').click();
});